export default "__VITE_ASSET__gC5Ir8jt__"